import { CustomButton } from "@/components/ui/Buttons";
import { Link } from "react-router-dom";

const ApplicationPendingBanner = () => {
  return (
    <div className="p-4 rounded-xl bg-[#F7FAFF] border border-dashed border-[#D0D5DD] flex flex-col md:flex-row gap-y-2.5 justify-between md:items-center">
      <div className="space-y-2.5">
        <div className="flex justify-between md:justify-normal gap-5 ">
          <h2 className="text-sm md:text-lg leading-4 md:leading-[22px] tracking-[-1%] font-semibold whitespace-nowrap">
            Waiting for Application Approval
          </h2>
          <div className="flex items-center gap-1 bg-[#456A97] px-3 py-[2px] rounded-[100px]">
            <div className="size-1.5 rounded-full bg-white" />
            <p className="text-white text-[10px] md:text-[11px] font-medium leading-4 whitespace-nowrap">
              Under Review
            </p>
          </div>
        </div>
        <p className="text-sm leading-5 tracking-[-1%] text-[#858D9D]">
          Your application has been submitted and is under review. We will
          notify you once it has been evaluated
        </p>
      </div>
      {/* <Link to={"/assignment"}>
        <CustomButton
          variant="outline"
          color="#333333"
          fontSize="14px"
          fontWeight="500"
          border="1px solid #C2C2C2"
          borderRadius="100px"
          padding="10px 24px"
          className="leading-5 tracking-[-1%]"
        >
          View Details
        </CustomButton>
      </Link> */}
    </div>
  );
};

export default ApplicationPendingBanner;
